<div>
  @if (tenantShopList.length > 1) {
    <div class="mb-2">
      @for (tenantShop of tenantShopList; track tenantShop) {
        <div class="d-flex d-inline-flex p-0 m-1" (click)="setActive(tenantShop.Id)">
          <button class="m-0 btn btn-small" [class.btn-primary]="activeTenantShop.Id == tenantShop.Id">{{tenantShop.Name}}</button>
        </div>
      }
    </div>
  }

  <t4-list-view #listVw [options]="listOptions" (onDataRequest)="onDataRequest($event)">

    <ng-container *t4ListActions>
      @if (!isInArchiveMode) {
        <button (click)="addNew()" class="btn btn-primary border" type="button"><i class="far fa-plus-square"></i>{{ 'GENERIC.BUTTON.ADDNEW' | translate}}</button>
      }
    </ng-container>

    <ng-container *t4ListItem="let item">
      <td>@if (item.IconCode !== null) {
        <i style="color: #8991a6" class="{{ item.IconCode }}"></i>
      }</td>
      <td>{{item.ShopLabelTypeTranslationCode | translate}}</td>
      <td>{{item.Name}}</td>
      <td>{{item.DisplayText | translate | replaceOnEmpty }}</td>
      <td>{{ (item.Show ? 'GENERIC.BOOLEANTYPE.YES' : 'GENERIC.BOOLEANTYPE.NO') | translate }}</td>
      <td>
        @if (item.Show) {
          {{item.ShowFrom | localDateTime | replaceOnEmpty }}
        } @else {
          -
        }
      </td>
      <td>
        @if (item.Show) {
          {{item.ShowTill | localDateTime | replaceOnEmpty }}
        } @else {
          -
        }
      </td>
      <td class="grid-action">
        <button (click)="openDetails(item)" type="button" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
        @if (!isInArchiveMode) {
          <button [disabled]="item.IsSystemLabel" (click)="deleteItem(item)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
        }
      </td>
    </ng-container>

  </t4-list-view>
</div>